import {z} from 'zod'

export type MergedRecommendationId = `merged-${string}`
export const MergedRecommendationId = z.string().startsWith('merged-') as z.ZodType<MergedRecommendationId>
